import React, { useState } from "react";
import { useDeleteUser, useGetUserRoles, useGetUsers } from "../../../backend/users";
import { CellTmpl, reactFormatter, DEFAULT_OPTIONS_PAYLOAD } from "../../common/Table";
import { toast } from "react-toastify";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useExportUsers } from "../../../backend/exports";
import { downloadFileContent } from "../../../utils/common";
import { TOOLTIP_DELAY } from "../../common/Constants";
import { ERROR_MESSAGES } from "../../../utils/constants";

import { User, UserSchema } from "../../../models/user";

import BaseList from '../../common/BaseList';
import UserDetails from "./UserDetails";
import AddEditUser from "./AddEditUser";


const INCLUDE_ASSOCIATION_COLUMNS = {
  roles: { only: ['id','name','pages'] }
};

const INCLUDE_ASSOCIATIONS = ['roles'];

function MangeUsers() {
    const [breadcrumb] = useState([
      { id: 'home', label: 'Home', path: '/' },
      { id: 'users', label: 'User Management', path: '/userManagement/roles' },
      { id: 'users', label: 'Manage Users' },
    ]);

    const initialPayload = { 
      includes: INCLUDE_ASSOCIATIONS,
      include: INCLUDE_ASSOCIATION_COLUMNS
    }

    const { records: roles } = useGetUserRoles({ 
      ...DEFAULT_OPTIONS_PAYLOAD 
    });

    const { exportRecords, exporting } = useExportUsers((response: any) => {
        downloadFileContent({
            name: 'Users.xlsx',
            type: response.headers['content-type'],
            content: response.data
        });
    }, () => {
        toast.error(ERROR_MESSAGES.DEFAULT);
    });

    const filterConfig = [
      {
        label: 'Role',
        name: 'roles_id_eq',
        options: (roles || []).map((x: any) => {
            return { value: x.id, label: x.name };
        })
      }
    ]

    function RoleTmpl({ cell }: any) {
      const roles = (cell.getValue() || []).map((x: any) => x.name).join(', ');
      return (
        <>
          {
            !!roles &&
            <div className="d-flex align-items-center h-100 w-auto">
                <OverlayTrigger overlay={<Tooltip>{roles}</Tooltip>} rootClose={true}
                    placement="bottom" delay={{ show: TOOLTIP_DELAY } as any}>
                    <div className="ellipse two-lines">{roles}</div>
                </OverlayTrigger>
            </div>
          }
        </>
      )
    }

    const columns = [
      { title: "Name", field: "name", formatter: reactFormatter(<CellTmpl />) },
      { title: "Username", field: "user_name", formatter: reactFormatter(<CellTmpl />) },
      { title: "Role", field: "roles", formatter: reactFormatter(<RoleTmpl />) },
      { title: "Email", field: "email", formatter: reactFormatter(<CellTmpl />) },
    ]

    function handleRecords() {
      //if (total > 0) {
      //  exportUsers({ ...payload, pagination: null });
      //}
    }

    return (
      <BaseList
        fetchData={useGetUsers}
        deleteData={useDeleteUser}
        nameAttribute={'name'}
        columns={columns}
        exportData={useExportUsers}
        DetailView={UserDetails}
        FormView={AddEditUser}
        modelSchema={UserSchema}
        initialSort={['name asc']}
        breadcrumb={breadcrumb}
        initialPayload={initialPayload}
        filterConfig={filterConfig}
        title="Manage Users"
      />
    );
}

export default MangeUsers;
